module.exports = __webpack_public_path__ + "img/Summary_of_Architectural_Fit.433c0ee8.jpeg";